export default "__VITE_ASSET__CHlIkjGz__"